exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-item{\r\n  color: #e95911 !important;\r\n}\r\n/* .btn-primary{\r\n  color: #e95911 !important;\r\n  background-color: #fff;\r\n  border-color: #e95911 !important;\r\n}\r\n.btn-primary:hover{\r\n    background-color: #fff !important;\r\n}\r\n\r\n.btn-primary::after{\r\n  background-color: #fff !important;\r\n}\r\n.btn-primary:focus{\r\n  background-color: #fff !important;\r\n} */\r\n.col-2{\r\n  padding: 0px;\r\n  margin: 4px !important;\r\n}\r\na{\r\n  color: #e95911 !important;\r\n  /* padding-right: 5px !important;\r\n  padding-left: 5px !important; */\r\n}\r\nul{\r\n  padding-right: 3%;\r\n}\r\n#filtro{\r\n  width: 13%;\r\n  padding-left: 8px;\r\n}\r\n@media only screen and (min-width: 150px) and (max-width: 990px){\r\n\r\n #filtro {\r\n      width:100%;\r\n      padding-top: 3px;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main